/* eslint-disable @typescript-eslint/no-explicit-any */
import { ReturnBackIcon, TrashIcon } from '@/icons';
import {
  AddPageIcon,
  GraphPaperIcon,
  LinePaperIcon,
  SavePageIcon,
} from '@/icons/WhiteBoardIcons';
import { setDisplayType } from '@/redux-store/slices/bookStore';
import { BookModel, DisplayTypes } from '@/types';
import React, { useEffect, useState } from 'react';
import { User } from '@/database/userDatabaseService';
import {
  BlankPage,
  deleteUserPage,
  getUserPages,
  saveUserPage,
} from '@/database/userPageDatabaseService';
import { formatDateToString } from '@/utility/utils';

interface BlankPageToolsProps {
  dispatch: (action: any) => void;
  previousDisplayType: DisplayTypes;
  setBlankPages: (pages: BlankPage[]) => void;
  setCurrentBlankPage: (blankPage: BlankPage) => void;
  canvas: any;
  currentBlankPage: BlankPage;
  blankPages: BlankPage[];
  user: User;
  book: BookModel;
}
const BlankPageTools: React.FC<BlankPageToolsProps> = ({
  dispatch,
  previousDisplayType,
  setBlankPages,
  setCurrentBlankPage,
  canvas,
  currentBlankPage,
  blankPages,
  user,
  book,
}) => {
  const [isMobile, setIsMobile] = useState<boolean>(false);
  
  // Ekran boyutunu kontrol edelim
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  const returnBack = () => {
    if (previousDisplayType === DisplayTypes.BlankPage) {
      dispatch(setDisplayType(DisplayTypes.Page));
    } else {
      dispatch(setDisplayType(previousDisplayType));
    }
  };

  const addPage = async () => {
    const json = JSON.stringify(canvas.toJSON());
    let pages = [
      ...blankPages.map((item) => {
        const temp = Object.assign({}, item);
        if (
          currentBlankPage.id === item.id &&
          currentBlankPage.createdDate === item.createdDate
        ) {
          temp.json = json;
        }
        return temp;
      }),
    ];
    const newPage: BlankPage = {
      id: null,
      userId: user.id,
      json: '',
      bookId: book.id,
      title: '',
      paperType: '',
      dataUrl: '',
      createdDate: formatDateToString(new Date()),
    };
    pages = [newPage].concat(pages);
    dispatch(setBlankPages(pages));
    dispatch(setCurrentBlankPage(newPage));
  };

  const savePage = async () => {
    const json = JSON.stringify(canvas.toJSON());
    const dataUrl = canvas.toDataURL();
    const page = { ...currentBlankPage };
    const pageIndex = blankPages?.filter((page) => page.id).length + 1;
    if (!page.id) {
      page.title = `${pageIndex}. Sayfa`;
    }
    page.json = json;
    page.dataUrl = dataUrl;
    const blankPage = await saveUserPage(page);
    const pages = await getUserPages(user.id, book.id);
    dispatch(setBlankPages(pages));
    dispatch(setCurrentBlankPage(blankPage));
  };

  const changePaperType = (paperType: string) => {
    const json = JSON.stringify(canvas.toJSON());
    const page = { ...currentBlankPage, json, paperType };
    dispatch(setCurrentBlankPage(page));
  };

  const deletePage = async () => {
    const currentIndex = blankPages.findIndex(
      (x) =>
        x.id === currentBlankPage.id &&
        x.createdDate === currentBlankPage.createdDate,
    );
    if (currentBlankPage.id) {
      await deleteUserPage(currentBlankPage.id);
      const pages = [...blankPages].filter(
        (page) => page.id !== currentBlankPage.id,
      );
      dispatch(setBlankPages(pages));
      if (currentIndex >= 0) {
        if (pages[currentIndex - 1]) {
          dispatch(setCurrentBlankPage(pages[currentIndex - 1]));
        } else {
          addPage();
        }
      } else {
        if (pages[0]) {
          dispatch(setCurrentBlankPage(pages[0]));
        } else {
          addPage();
        }
      }
    }
  };
  return (
    <div className={`content-tools ${isMobile ? 'mobile-blank-tools' : ''}`} style={{zIndex: 2000}}>
      <button className="return-back-btn" onClick={returnBack}>
        <ReturnBackIcon className={undefined} />
      </button>
      <button onClick={() => addPage()}>
        <AddPageIcon className={undefined} />
      </button>
      <button onClick={() => changePaperType('graph-paper')}>
        <GraphPaperIcon className={undefined} />
      </button>
      <button onClick={() => changePaperType('lined-paper')}>
        <LinePaperIcon className={undefined} />
      </button>
      <button onClick={() => savePage()}>
        <SavePageIcon className={undefined} />
      </button>
      {currentBlankPage && currentBlankPage.id && (
        <button onClick={() => deletePage()}>
          <TrashIcon color="#7E92A2" className={undefined} />
        </button>
      )}
    </div>
  );
};

export default BlankPageTools;
